import {
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import { Switch as MUISwitch } from "@material-ui/core";
import React from "react";

const Switch = ({
  fullWidth,
  error,
  helperText,
  required = false,
  value,
  ...rest
}) => {
  return (
    <FormControl fullWidth={fullWidth} error={error} required={required}>
      <FormControlLabel
        control={<MUISwitch size="small" color="primary" checked={value} />}
        {...rest}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default Switch;
